'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalContextProvider = exports.ModalContext = exports.defaultModalContext = undefined;

var _react = require('react');

var _emptyFunction = require('react-utils/emptyFunction');

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultModalContext = exports.defaultModalContext = {
  use: 'default',
  headerCallback: _emptyFunction2.default
};

var ModalContext = exports.ModalContext = (0, _react.createContext)(defaultModalContext);

var Provider = ModalContext.Provider;
exports.ModalContextProvider = Provider;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/context/ModalContext.js
// module id = 549
// module chunks = 177